import { IUserBase } from '@shared/interfaces';
import { ITeam, ITeamType, IGroupOfUsers } from '../../interfaces';
import { allMemberTypes, TTeamMemberType } from './RoleAssignmentModel';

export interface ITeamSelection extends ITeam {
  teamDirectors: IUserBase[];
  teamId: string;
  teamName: string;
  includeFullTeam: boolean;
  includedTeamMemberType: TTeamMemberType[];
}

export interface ILoggeRoundRobindUser {
  userId: string;
  userName: string;
  teamMemberType: TTeamMemberType;
}

export interface ITeamTypeSelection extends ITeamType {
  teamTypeId: string;
  teamTypeName: string;
  includeFullTeamType: boolean;
  teams: ITeamSelection[];
  includeManager: boolean;
  includedTeamMemberType: TTeamMemberType[];
}

export interface IRoleAssignmentSelection extends IGroupOfUsers {
  allUsers: boolean;
  teamType: ITeamTypeSelection[];
  teams: ITeamSelection[];
  includeAllManagers: boolean;
  includeAllDirectors: boolean;
  includeAllLieutenants: boolean;
}

export class TeamSelection implements ITeamSelection {
  teamId = '';
  teamName = '';
  includeFullTeam = false;
  includedTeamMemberType: TTeamMemberType[] = [];
  teamDirectors: IUserBase[] = [];
  teamLieutenants: IUserBase[] = [];
  teamMembers: IUserBase[] = [];

  constructor(data?: ITeamSelection, includeFullTeamType?: boolean) {
    if (data) {
      this.teamId = data?.teamId;
      this.teamName = data?.teamName;
      this.includeFullTeam = Boolean(includeFullTeamType || data?.includeFullTeam);
      this.includedTeamMemberType = this.includeFullTeam ? allMemberTypes : data?.includedTeamMemberType || [];
      this.teamDirectors = data?.teamDirectors;
      this.teamLieutenants = data?.teamLieutenants;
      this.teamMembers = data?.teamMembers;
    }
  }
}

export class TeamTypeSelection implements ITeamTypeSelection {
  teamTypeId = '';
  teamTypeName = '';
  includeFullTeamType = false;
  includeManager = false;
  includedTeamMemberType: TTeamMemberType[] = [];
  teams: ITeamSelection[] = [];
  teamTypeManagers: string[] = [];

  constructor(data?: ITeamTypeSelection, allUsers?: boolean) {
    if (data) {
      this.teamTypeId = data?.teamTypeId;
      this.teamTypeName = data?.teamTypeName;
      this.includeFullTeamType = allUsers || !!data?.includeFullTeamType;
      this.includeManager = this.includeFullTeamType || !!data?.includeManager;
      this.includedTeamMemberType = this.includeFullTeamType ? allMemberTypes : data?.includedTeamMemberType || [];
      this.teamTypeManagers = data?.teamTypeManagers;
      this.teams = data?.teams?.map((team) => new TeamSelection(team, this.includeFullTeamType)) || [];
    }
  }
}

export class RoleAssignmentSelection implements IRoleAssignmentSelection {
  allUsers = false;
  teamType: ITeamTypeSelection[] = [];
  teams: ITeamSelection[] = [];
  includeAllManagers = false;
  includeAllDirectors = false;
  includeAllLieutenants = false;
  allManagers: IUserBase[] = [];
  allTeamDirectors: IUserBase[] = [];
  allTeamLieutenants: IUserBase[] = [];

  constructor(data?: Partial<IRoleAssignmentSelection>) {
    if (data) {
      this.allUsers = !!data?.allUsers;
      this.includeAllManagers = !!data?.allUsers || !!data?.includeAllManagers;
      this.includeAllDirectors = !!data?.allUsers || !!data?.includeAllDirectors;
      this.includeAllLieutenants = !!data?.allUsers || !!data?.includeAllLieutenants;
      this.teamType = data?.teamType?.map((teamType) => new TeamTypeSelection(teamType, data?.allUsers)) || [];
      this.teams = data?.teams?.map((team) => new TeamSelection(team, data?.allUsers)) || [];

      this.allManagers = data.allManagers || [];
      this.allTeamDirectors = data.allTeamDirectors || [];
      this.allTeamLieutenants = data.allTeamLieutenants || [];
    }
  }
}
